import { useParams } from 'react-router';
import { ConversationsTable } from 'widgets/conversations-table';

export const ConversationsPage = () => {
  const { personaId } = useParams();

  return <ConversationsTable personaId={personaId} />;
};
